import React from 'react';

/* ═══════════════════════════════════════════════════════════════════════════
   HUPALUPA STORE — EYLÜL 2026 MEDYA PLANI (MARKA BÜTÇESİ)      ₺1.215.000
   ---------------------------------------------------------------------------
   3 Eylül 2026. Bu sayfa `/budget/hupalupa-store-eylul-2026-medya-plani`
   sayfasının YERİNE geçmez, onun YANINDA durur. Farkı tek cümleyle:

     · Eski sayfa  → bütçe BİZİM önerimiz (₺1.310.000), kanal dağılımı bizim.
     · Bu sayfa    → bütçe MARKANIN verdiği gibi (₺1.215.000), kanal dağılımı
                     yine bizim. Markanın Excel'indeki kanal yüzdeleri
                     KULLANILMADI (gerekçe aşağıda, "Neden kendi dağılımımız").

   🔑 Efe'nin talimatı (3 Eyl): "bütçe olarak markanın verdiği gibi yapacağız,
   bizim Hupalupa Store dediğimiz bütçe buradaki ESNEK bütçe olacak, Instagram/
   TikTok/YouTube dağılımını kendi bildiğimiz gibi yapalım."

   🔑 Marka kalemlerinin dip toplamları BİREBİR markanın verdiği rakam.
   `BUTCE` içindeki her sayı markadan geldi; `PLAN` satırlarının marka bazlı
   toplamı bu sayıya kapanmak ZORUNDA — sayfa açılırken kontrol ediyor
   (butceKontrol). Kanal kırılımı bize ait.
   ═══════════════════════════════════════════════════════════════════════════ */

/* ── Kampanya amacı rozeti ───────────────────────────────────────────────── */
const AMAC_STIL = {
  'Dönüşüm': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Farkındalık': 'bg-red-50 text-red-700 border-red-200',
  'Etkileşim': 'bg-pink-50 text-pink-700 border-pink-200',
};
function Amac({ tip }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${AMAC_STIL[tip] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
      {tip}
    </span>
  );
}

const MECRA = {
  google: { ad: 'Google Ads', logo: '/google_ads-512.webp', satir: 'bg-blue-50 text-blue-800' },
  meta:   { ad: 'Meta Ads',   logo: '/6033716.png',          satir: 'bg-indigo-50 text-indigo-800' },
  tiktok: { ad: 'TikTok Ads', logo: '/tiktokv4.svg',         satir: 'bg-gray-100 text-gray-800' },
};

/* ── MARKA KALEMLERİ ─────────────────────────────────────────────────────────
   butce  : markadan geldiği gibi, DEĞİŞTİRİLMEZ.
   oneri  : bizim 1 Eylül'deki önerimiz (karşılaştırma için; yoksa 0 = yeni kalem)
   ciro   : GA4 ürün performansı, 1 Mar – 31 Ağu 2026 (Ciro Röntgeni ile aynı sayı)
   urun   : kaynak feed'de o markaya ait ürün sayısı — 3 Eyl 2026'da feed'in
            KENDİSİNDEN sayıldı (4.325 item, `brand` alanı). "Okul Setleri" ve
            "Yabancı dil kitapları" marka değil kategori olduğu için onlarda
            `product_type` sayıldı (Kırtasiye 839 · İngilizce Çocuk Kitapları 456).
   Logosu olmayan kalemler tipografik kutuyla gösteriliyor — "Okul Setleri",
   "Yabancı dil kitapları" ve "Esnek" zaten marka değil, kalem. */
const KALEMLER = [
  { key: 'needoh',    ad: 'NeeDoh',                  logo: '/logos/markalar/needoh.svg',      butce: 600000, oneri: 600000, ciro: 0,       urun: 0, tur: 'Squishy',          onem: 'Yeni lanse edilen ürün' },
  { key: 'esnek',     ad: 'Esnek bütçe',             logo: null,                              butce: 150000, oneri: 400000, ciro: null,    urun: null, tur: 'Genel katalog',    onem: 'Performansa göre kaydırılır' },
  { key: 'playmobil', ad: 'Playmobil',               logo: '/logos/markalar/playmobil.svg',   butce: 80000,  oneri: 150000, ciro: 55780,   urun: 65,  tur: 'Yapı oyuncağı',    onem: 'Yeni lanse edilen ürün' },
  { key: 'antonio',   ad: 'Antonio Juan',            logo: '/logos/markalar/antoniojuan.svg', butce: 80000,  oneri: 40000,  ciro: 332100,  urun: 28,   tur: 'Oyuncak bebek',    onem: "Yeni SKU'lar tuttu" },
  { key: 'smiggle',   ad: 'Smiggle',                 logo: null,                              butce: 50000,  oneri: 0,      ciro: 113309,  urun: 64,  tur: 'Çanta',            onem: 'Back to School' },
  { key: 'b2s',       ad: 'Okul Setleri / B2S',      logo: null,                              butce: 50000,  oneri: 0,      ciro: 1228160, urun: 839, tur: 'Genel',           onem: 'Back to School' },
  { key: 'zoo',       ad: 'Zoo Family',              logo: '/logos/markalar/zoofamily.svg',   butce: 50000,  oneri: 30000,  ciro: 512501,  urun: 13,    tur: 'Çocuk kamerası',   onem: 'Hediyelik' },
  { key: 'xmud',      ad: 'X Mud',                   logo: '/logos/markalar/xmud.png',        butce: 45000,  oneri: 40000,  ciro: 5250,    urun: 14,    tur: 'Slime',            onem: 'Trend' },
  { key: 'modu',      ad: 'Modu',                    logo: null,                              butce: 30000,  oneri: 0,      ciro: 313817,  urun: 36,   tur: 'Yapı oyuncağı',    onem: 'Hediyelik' },
  { key: 'charmit',   ad: 'Charm It',                logo: '/logos/markalar/charmit.png',     butce: 30000,  oneri: 50000,  ciro: 7929,    urun: 55,    tur: 'Takı',             onem: 'Yeni lanse edilen ürün' },
  { key: 'meli',      ad: 'Meli',                    logo: null,                              butce: 30000,  oneri: 0,      ciro: 64121,   urun: 26,    tur: 'Yapı oyuncağı',    onem: 'Genel' },
  { key: 'kitap',     ad: 'Yabancı dil kitapları',   logo: null,                              butce: 20000,  oneri: 0,      ciro: 67582,   urun: 456,  tur: 'Kitap',            onem: 'Back to School' },
];

/* ── MARKANIN EXCEL'İNDEKİ KANAL DAĞILIMI (kullanılmadı, kıyas için) ────────
   Sayılar markanın gönderdiği tablodan birebir alındı. Instagram sütunu Meta'ya,
   YouTube sütunu Google'a denk düşüyor — kıyas tablosunda öyle toplanıyor. */
const MARKA_DAGILIM = [
  { key: 'smiggle',   instagram: 15000,  tiktok: 7500,   youtube: 0,     pinterest: 12500, search: 15000, pmax: 0 },
  { key: 'b2s',       instagram: 10000,  tiktok: 7500,   youtube: 0,     pinterest: 15000, search: 17500, pmax: 0 },
  { key: 'playmobil', instagram: 20000,  tiktok: 16000,  youtube: 24000, pinterest: 0,     search: 0,     pmax: 20000 },
  { key: 'antonio',   instagram: 24000,  tiktok: 0,      youtube: 16000, pinterest: 20000, search: 20000, pmax: 0 },
  { key: 'needoh',    instagram: 120000, tiktok: 240000, youtube: 60000, pinterest: 0,     search: 60000, pmax: 120000 },
  { key: 'zoo',       instagram: 15000,  tiktok: 7500,   youtube: 12500, pinterest: 0,     search: 15000, pmax: 0 },
  { key: 'modu',      instagram: 16500,  tiktok: 13500,  youtube: 0,     pinterest: 0,     search: 0,     pmax: 0 },
  { key: 'xmud',      instagram: 15750,  tiktok: 29250,  youtube: 0,     pinterest: 0,     search: 0,     pmax: 0 },
  { key: 'charmit',   instagram: 12000,  tiktok: 18000,  youtube: 0,     pinterest: 0,     search: 0,     pmax: 0 },
  { key: 'meli',      instagram: 16500,  tiktok: 13500,  youtube: 0,     pinterest: 0,     search: 0,     pmax: 0 },
  { key: 'kitap',     instagram: 0,      tiktok: 0,      youtube: 0,     pinterest: 7000,  search: 13000, pmax: 0 },
];

/* ── PLAN — kanal ve kampanya kırılımı BİZE ait ──────────────────────────────
   Birim maliyetler Ağustos 2026'da bu hesapta GERÇEKLEŞEN değerler; karşılığı
   olmayanlar (TikTok, video izlenme) benchmark olarak işaretli.

   🔑 Marka katalog satırlarında cpc 4,50 / cpm 190 kullanıldı. Bu bir ARA
   değer: Ağustos'ta marka-izole Meta kampanyaları ₺10,74-14,57 CPC ile çalıştı,
   marka ayrımsız katalog motoru ₺2,49-3,15 ile. Biz marka silosunu AYRI kampanya
   olarak değil, katalog motorunun içinde ÜRÜN SETİ olarak kurmayı öneriyoruz —
   maliyetin motor tarafına yakın kalmasının tek yolu bu. Yine de varsayımdır;
   set olarak kurulmazsa CPC iki katına çıkar ve tıklama tahminleri yarılanır. */
const PLAN = [
  /* ── NEEDOH ₺600.000 ── */
  { marka: 'needoh', mecra: 'google', kampanya: 'Search — NeeDoh Marka', kitle: '"needoh", "nee doh", "needoh nice cube" arayanlar', amac: 'Dönüşüm', butce: 70000, cpc: 4.50, cpm: 340, kaynak: 'gercek' },
  { marka: 'needoh', mecra: 'google', kampanya: 'Search — Kategori', kitle: '"stres oyuncağı", "squishy oyuncak", "fidget oyuncak"', amac: 'Dönüşüm', butce: 50000, cpc: 6.00, cpm: 420, kaynak: 'gercek' },
  { marka: 'needoh', mecra: 'google', kampanya: 'Performance Max — NeeDoh ürün grubu', kitle: 'Geniş + alışveriş sinyalli · NeeDoh asset grubu', amac: 'Dönüşüm', butce: 90000, cpc: 7.69, cpm: 142, kaynak: 'gercek', sart: 'feed' },
  { marka: 'needoh', mecra: 'google', kampanya: 'Shopping — NeeDoh', kitle: 'Ürün adı arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 20000, cpc: 1.09, cpm: 30, kaynak: 'gercek', sart: 'feed' },
  { marka: 'needoh', mecra: 'google', kampanya: 'YouTube — squish filmi', kitle: '13-35 · fidget, ASMR, oyuncak içeriği izleyicileri', amac: 'Farkındalık', butce: 50000, cpv: 0.12, cpm: 33.5, kaynak: 'benchmark' },
  { marka: 'needoh', mecra: 'meta', kampanya: 'Advantage+ Catalog — NeeDoh ürün seti', kitle: 'Geniş prospecting · katalog motoru içinde NeeDoh seti', amac: 'Dönüşüm', butce: 130000, cpc: 4.50, cpm: 190, kaynak: 'gercek', sart: 'feed' },
  { marka: 'needoh', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'NeeDoh ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 40000, cpc: 2.53, cpm: 163, kaynak: 'gercek', sart: 'feed' },
  { marka: 'needoh', mecra: 'meta', kampanya: 'Video Views — ASMR / duyusal', kitle: 'Geniş prospecting 13-35 · ASMR ve duyusal içerik', amac: 'Farkındalık', butce: 70000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },
  { marka: 'needoh', mecra: 'meta', kampanya: 'Sales — Lansman kreatifleri', kitle: 'Fidget / duyusal oyuncak ilgi alanları · Lookalike %1-3', amac: 'Dönüşüm', butce: 40000, cpc: 8.90, cpm: 256, kaynak: 'gercek' },
  { marka: 'needoh', mecra: 'tiktok', kampanya: 'Video Views', kitle: 'Fidget / squish içeriği izleyicileri · geniş 13-35', amac: 'Farkındalık', butce: 40000, cpv: 0.06, cpm: 25, kaynak: 'benchmark', sart: 'hesap' },

  /* ── ESNEK BÜTÇE ₺150.000 ── */
  { marka: 'esnek', mecra: 'google', kampanya: 'Esnek — kanal dağılımı ay içinde belirlenir', kitle: 'Genel katalog motoru · performansa göre kaydırılır', amac: 'Dönüşüm', butce: 150000, kaynak: 'esnek' },

  /* ── PLAYMOBIL ₺80.000 ── */
  { marka: 'playmobil', mecra: 'google', kampanya: 'Search — Playmobil Marka', kitle: '"playmobil" ve ürün kodu arayanlar', amac: 'Dönüşüm', butce: 10000, cpc: 4.00, cpm: 340, kaynak: 'gercek' },
  { marka: 'playmobil', mecra: 'google', kampanya: 'Search — Generic', kitle: '"yapı oyuncakları", "oyun seti", "figür oyuncak"', amac: 'Dönüşüm', butce: 10000, cpc: 6.50, cpm: 450, kaynak: 'gercek' },
  { marka: 'playmobil', mecra: 'google', kampanya: 'Performance Max — Playmobil ürün grubu', kitle: 'Geniş + alışveriş sinyalli · Playmobil asset grubu', amac: 'Dönüşüm', butce: 22000, cpc: 7.69, cpm: 142, kaynak: 'gercek' },
  { marka: 'playmobil', mecra: 'google', kampanya: 'YouTube — oynanış / koleksiyon', kitle: '25-45 ebeveyn · oyuncak inceleme izleyicileri', amac: 'Farkındalık', butce: 6000, cpv: 0.12, cpm: 33.5, kaynak: 'benchmark' },
  { marka: 'playmobil', mecra: 'meta', kampanya: 'Advantage+ Catalog — Playmobil ürün seti', kitle: 'Geniş prospecting · katalog motoru içinde Playmobil seti', amac: 'Dönüşüm', butce: 24000, cpc: 4.50, cpm: 190, kaynak: 'gercek' },
  { marka: 'playmobil', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'Playmobil ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 8000, cpc: 2.53, cpm: 163, kaynak: 'gercek' },

  /* ── ANTONIO JUAN ₺80.000 ── */
  { marka: 'antonio', mecra: 'google', kampanya: 'Search — Marka + Generic', kitle: '"antonio juan", "et bebek", "oyuncak bebek" arayanlar', amac: 'Dönüşüm', butce: 14000, cpc: 6.30, cpm: 730, kaynak: 'gercek' },
  { marka: 'antonio', mecra: 'google', kampanya: 'Performance Max — Antonio Juan ürün grubu', kitle: 'Geniş + alışveriş sinyalli · AJ asset grubu', amac: 'Dönüşüm', butce: 20000, cpc: 7.69, cpm: 142, kaynak: 'gercek' },
  { marka: 'antonio', mecra: 'google', kampanya: 'Shopping — Antonio Juan', kitle: 'Oyuncak bebek arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 6000, cpc: 1.09, cpm: 30, kaynak: 'gercek' },
  { marka: 'antonio', mecra: 'meta', kampanya: 'Advantage+ Catalog — AJ ürün seti', kitle: 'Geniş prospecting · katalog motoru içinde AJ seti', amac: 'Dönüşüm', butce: 26000, cpc: 4.50, cpm: 190, kaynak: 'gercek' },
  { marka: 'antonio', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'AJ ürünlerini gören / sepete ekleyen · yüksek sepet', amac: 'Dönüşüm', butce: 8000, cpc: 2.53, cpm: 163, kaynak: 'gercek' },
  { marka: 'antonio', mecra: 'meta', kampanya: 'Video Views — unboxing', kitle: 'Hediye ve koleksiyon ilgi alanları · 25-45 kadın', amac: 'Farkındalık', butce: 6000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },

  /* ── SMIGGLE ₺50.000 ── */
  { marka: 'smiggle', mecra: 'google', kampanya: 'Search — Okul çantası + Smiggle', kitle: '"okul çantası", "smiggle", "kalem kutusu" arayanlar', amac: 'Dönüşüm', butce: 10000, cpc: 6.50, cpm: 450, kaynak: 'gercek' },
  { marka: 'smiggle', mecra: 'google', kampanya: 'Performance Max — Smiggle ürün grubu', kitle: 'Geniş + alışveriş sinyalli · Smiggle asset grubu', amac: 'Dönüşüm', butce: 12000, cpc: 7.69, cpm: 142, kaynak: 'gercek' },
  { marka: 'smiggle', mecra: 'meta', kampanya: 'Advantage+ Catalog — Smiggle ürün seti', kitle: 'Geniş prospecting · katalog motoru içinde Smiggle seti', amac: 'Dönüşüm', butce: 16000, cpc: 4.50, cpm: 190, kaynak: 'gercek' },
  { marka: 'smiggle', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'Smiggle ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 6000, cpc: 2.53, cpm: 163, kaynak: 'gercek' },
  { marka: 'smiggle', mecra: 'meta', kampanya: 'Video Views — okul hazırlığı', kitle: '6-14 çocuk ebeveyni · okul dönemi ilgi alanları', amac: 'Farkındalık', butce: 6000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },

  /* ── OKUL SETLERİ / B2S ₺50.000 ── */
  { marka: 'b2s', mecra: 'google', kampanya: 'Search — Kırtasiye ve okul', kitle: '"kırtasiye", "beslenme çantası", "suluk", "kalem seti"', amac: 'Dönüşüm', butce: 15000, cpc: 6.50, cpm: 450, kaynak: 'gercek' },
  { marka: 'b2s', mecra: 'google', kampanya: 'Performance Max — Kırtasiye ürün grubu', kitle: 'Geniş + alışveriş sinyalli · kırtasiye asset grubu', amac: 'Dönüşüm', butce: 12000, cpc: 7.69, cpm: 142, kaynak: 'gercek' },
  { marka: 'b2s', mecra: 'google', kampanya: 'Shopping — Kırtasiye', kitle: 'Ürün adı / kategori arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 5000, cpc: 1.09, cpm: 30, kaynak: 'gercek' },
  { marka: 'b2s', mecra: 'meta', kampanya: 'Advantage+ Catalog — Kırtasiye seti', kitle: 'Geniş prospecting · katalog motoru içinde kırtasiye seti', amac: 'Dönüşüm', butce: 13000, cpc: 3.15, cpm: 152, kaynak: 'gercek' },
  { marka: 'b2s', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'Kırtasiye ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 5000, cpc: 2.53, cpm: 163, kaynak: 'gercek' },

  /* ── ZOO FAMILY ₺50.000 ── */
  { marka: 'zoo', mecra: 'google', kampanya: 'Search — Generic', kitle: '"çocuk fotoğraf makinesi", "çocuk kamerası"', amac: 'Dönüşüm', butce: 12000, cpc: 6.50, cpm: 450, kaynak: 'gercek' },
  { marka: 'zoo', mecra: 'google', kampanya: 'Performance Max — Zoo Family ürün grubu', kitle: 'Geniş + alışveriş sinyalli · Zoo Family asset grubu', amac: 'Dönüşüm', butce: 13000, cpc: 7.69, cpm: 142, kaynak: 'gercek' },
  { marka: 'zoo', mecra: 'meta', kampanya: 'Advantage+ Catalog — Zoo Family ürün seti', kitle: 'Geniş prospecting · katalog motoru içinde Zoo seti', amac: 'Dönüşüm', butce: 15000, cpc: 4.50, cpm: 190, kaynak: 'gercek' },
  { marka: 'zoo', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'Zoo Family ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 5000, cpc: 2.53, cpm: 163, kaynak: 'gercek' },
  { marka: 'zoo', mecra: 'meta', kampanya: 'Video Views — ürün demo', kitle: 'Hediye arayan ebeveyn · teknoloji ve fotoğraf ilgi alanları', amac: 'Farkındalık', butce: 5000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },

  /* ── X MUD ₺45.000 ── */
  { marka: 'xmud', mecra: 'google', kampanya: 'Search — Generic (slime)', kitle: '"slime", "slime seti", "hazır slime" arayanlar', amac: 'Dönüşüm', butce: 14000, cpc: 5.00, cpm: 380, kaynak: 'gercek' },
  { marka: 'xmud', mecra: 'google', kampanya: 'Shopping / PMax — X Mud', kitle: 'Slime ve oyun hamuru arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 8000, cpc: 2.00, cpm: 55, kaynak: 'gercek' },
  { marka: 'xmud', mecra: 'meta', kampanya: 'Advantage+ Catalog — X Mud ürün seti', kitle: 'Geniş prospecting · katalog motoru içinde X Mud seti', amac: 'Dönüşüm', butce: 9000, cpc: 4.50, cpm: 190, kaynak: 'gercek' },
  { marka: 'xmud', mecra: 'meta', kampanya: 'Video Views — slime / ASMR', kitle: '7-16 ve ebeveyni · slime ve DIY içerik izleyicileri', amac: 'Farkındalık', butce: 8000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },
  { marka: 'xmud', mecra: 'tiktok', kampanya: 'Video Views', kitle: 'Slime ve ASMR içeriği izleyicileri', amac: 'Farkındalık', butce: 6000, cpv: 0.06, cpm: 25, kaynak: 'benchmark', sart: 'hesap' },

  /* ── MODU ₺30.000 ── */
  { marka: 'modu', mecra: 'google', kampanya: 'Search — Generic', kitle: '"modu blok", "yapı oyuncağı", "bloklar" arayanlar', amac: 'Dönüşüm', butce: 8000, cpc: 6.50, cpm: 450, kaynak: 'gercek' },
  { marka: 'modu', mecra: 'google', kampanya: 'Performance Max — Modu ürün grubu', kitle: 'Geniş + alışveriş sinyalli · Modu asset grubu', amac: 'Dönüşüm', butce: 9000, cpc: 7.69, cpm: 142, kaynak: 'gercek' },
  { marka: 'modu', mecra: 'meta', kampanya: 'Advantage+ Catalog — Modu ürün seti', kitle: 'Geniş prospecting · katalog motoru içinde Modu seti', amac: 'Dönüşüm', butce: 10000, cpc: 4.50, cpm: 190, kaynak: 'gercek' },
  { marka: 'modu', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'Modu ürünlerini gören / sepete ekleyen · yüksek sepet', amac: 'Dönüşüm', butce: 3000, cpc: 2.53, cpm: 163, kaynak: 'gercek' },

  /* ── CHARM IT ₺30.000 ── */
  { marka: 'charmit', mecra: 'google', kampanya: 'Shopping / PMax — Charm It ürün grubu', kitle: 'Takı ve aksesuar arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 9000, cpc: 2.50, cpm: 60, kaynak: 'gercek' },
  { marka: 'charmit', mecra: 'meta', kampanya: 'Advantage+ Catalog — Charm It ürün seti', kitle: 'Geniş prospecting · katalog motoru içinde Charm It seti', amac: 'Dönüşüm', butce: 12000, cpc: 4.50, cpm: 190, kaynak: 'gercek' },
  { marka: 'charmit', mecra: 'meta', kampanya: 'Catalog Remarketing', kitle: 'Charm It ürünlerini gören / sepete ekleyen', amac: 'Dönüşüm', butce: 4000, cpc: 2.53, cpm: 163, kaynak: 'gercek' },
  { marka: 'charmit', mecra: 'meta', kampanya: 'Video Views — koleksiyon / DIY', kitle: '8-14 kız çocuk ebeveyni · takı ve hediye ilgi alanları', amac: 'Farkındalık', butce: 5000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },

  /* ── MELİ ₺30.000 ── */
  { marka: 'meli', mecra: 'google', kampanya: 'Search — Generic', kitle: '"bloklar", "yapı oyuncağı", "eğitici blok" arayanlar', amac: 'Dönüşüm', butce: 7000, cpc: 6.50, cpm: 450, kaynak: 'gercek' },
  { marka: 'meli', mecra: 'google', kampanya: 'Performance Max — Meli ürün grubu', kitle: 'Geniş + alışveriş sinyalli · Meli asset grubu', amac: 'Dönüşüm', butce: 8000, cpc: 7.69, cpm: 142, kaynak: 'gercek' },
  { marka: 'meli', mecra: 'meta', kampanya: 'Advantage+ Catalog — Meli ürün seti', kitle: 'Geniş prospecting · katalog motoru içinde Meli seti', amac: 'Dönüşüm', butce: 11000, cpc: 4.50, cpm: 190, kaynak: 'gercek' },
  { marka: 'meli', mecra: 'meta', kampanya: 'Video Views — yapım videosu', kitle: '3-8 çocuk ebeveyni · eğitici oyuncak ilgi alanları', amac: 'Farkındalık', butce: 4000, cpv: 0.09, cpm: 36, kaynak: 'benchmark' },

  /* ── YABANCI DİL KİTAPLARI ₺20.000 ── */
  { marka: 'kitap', mecra: 'google', kampanya: 'Search — Yabancı dil kitabı', kitle: '"ingilizce çocuk kitabı", "yabancı dil kitap seti"', amac: 'Dönüşüm', butce: 9000, cpc: 5.50, cpm: 400, kaynak: 'gercek' },
  { marka: 'kitap', mecra: 'google', kampanya: 'Shopping / PMax — Kitap ürün grubu', kitle: 'Kitap arayan alışveriş niyetli kullanıcı', amac: 'Dönüşüm', butce: 5000, cpc: 1.09, cpm: 30, kaynak: 'gercek' },
  { marka: 'kitap', mecra: 'meta', kampanya: 'Advantage+ Catalog — Kitap seti', kitle: 'Geniş prospecting · katalog motoru içinde kitap seti', amac: 'Dönüşüm', butce: 6000, cpc: 3.15, cpm: 152, kaynak: 'gercek' },
];

/* ── BİZ ŞÖYLE YAPARDIK — karşı öneri, dip toplam AYNI ───────────────────────
   3 Eylül. Yukarıdaki tablo markanın verdiği bütçedir ve DEĞİŞMEZ; bu blok
   onun altında duran ayrı bir öneridir. Toplam yine ₺1.215.000 — tek kuruş
   eklemiyoruz, sadece yerini değiştiriyoruz.

   Efe'nin talimatı: "Okul setlerini 200'e çıkar, Playmobil'i 150'ye çıkar,
   100 binini esnek bütçeden al, geri kalanını ufak ufak Modu / Antonio Juan /
   Meli'den al."

   🔑 Talimattan bir sapma var ve bilerek: gereken kaydırma ₺220.000, esnekten
   ₺100.000 gelince kalan ₺120.000. Modu + Antonio Juan + Meli'nin TOPLAMI
   ₺140.000 — ₺120.000'i o üçünden almak üçünü de fiilen kapatmak olurdu.
   Bu yüzden ₺65.000'i o üç kalemden, kalan ₺55.000'i "bütçe / aylık ciro"
   tablosunun en tepesindeki üç kalemden aldık (X Mud 51,4× · Charm It 22,7× ·
   Zoo Family beş ay üst üste düşen trend). Gerekçeler satır satır yazılı. */
const ONERI = [
  { key: 'b2s',       yeni: 200000, gerekce: 'Altı ayda ₺1.228.160 (%14,3) — ayrı bütçesi olmayan en büyük kalem. Ağustos’ta ₺390.492 ile ayın en büyük tek kalemiydi; 2025’te Eylül, Ağustos’un %72’si kadar geldi → Eylül beklentisi ~₺354.000. Oran 0,2× → 1,0×.' },
  { key: 'playmobil', yeni: 150000, gerekce: 'Marka araması 3.600/ay (NeeDoh dışında en yükseği), feed’de 65 ürün, ciro beş ay üst üste artıyor (Mar ₺1.200 → Ağu ₺29.388). Oran 8,6× → 16,1×: gerekçe mevcut ciro değil TREND — planın en riskli tek kalemi bu olur.' },
  { key: 'esnek',     yeni: 50000,  gerekce: 'Tek başına bakınca genel motor küçülüyor görünür; değil. B2S de aynı Advantage+ motorunun içinde bir ürün setidir — esnek + B2S ₺200.000’den ₺250.000’e ÇIKIYOR. Motor büyüyor, sadece adı konuyor.' },
  { key: 'antonio',   yeni: 45000,  gerekce: 'Kesintiler içinde en tartışmalısı: altı ayda ₺332.100 ve trend yukarı (Mar ₺19.278 → Ağu ₺93.848). ₺45.000’de oran 0,8× ile hâlâ sağlıklı; bundan fazlası önerilmez.' },
  { key: 'xmud',      yeni: 20000,  gerekce: 'Altı ayda ₺5.250 ve hepsi tek ayda (Ağustos). 14 ürünün tamamı aynı fiyatta. Oran 51,4× → 22,9×; hâlâ yüksek ama yarıya indi.' },
  { key: 'zoo',       yeni: 35000,  gerekce: 'Nisan ₺164.516 → Ağustos ₺20.683, beş ay üst üste düşüş. Altı aylık toplam (₺512.501) yanıltıcı — marka sönüyor, bütçe geçmişe değil bugüne bakmalı.' },
  { key: 'charmit',   yeni: 15000,  gerekce: 'Altı ayda ₺7.929, marka araması 70/ay. Oran 22,7× → 11,4×.' },
  { key: 'modu',      yeni: 15000,  gerekce: 'Ciro ₺313.817 iyi ama Ağustos’ta marka-izole Meta kampanyası ROAS 0,31 ile hesabın en kötüsüydü. Katalog seti olarak ₺15.000 yeter; silo kanıtlanınca artırılır.' },
  { key: 'meli',      yeni: 15000,  gerekce: 'Altı ayda ₺64.121, yeni kalem. ₺15.000’de oran 1,4× — önce ölçülsün, sonra büyütülsün.' },
];
const ONERI_MAP = Object.fromEntries(ONERI.map((o) => [o.key, o]));
const oneriButce = (key) => (ONERI_MAP[key] ? ONERI_MAP[key].yeni : KALEMLER.find((k) => k.key === key).butce);
const ONERI_YENI_TOPLAM = KALEMLER.reduce((a, k) => a + oneriButce(k.key), 0);

/* ── Ağustos 2026 gerçekleşen (referans) ─────────────────────────────────── */
const AGUSTOS = {
  google: { harcama: 182463, cpc: 6.40, cpm: 166, ciro: 834254, roas: 4.57 },
  meta:   { harcama: 274215, cpc: 3.96, cpm: 98,  ciro: 688657, roas: 2.51 },
  toplam: { harcama: 456678, ciro: 1522911, roas: 3.34 },
  genelMotor: 434268,   // marka ayrımı olmayan genel katalog + arama harcaması
  markaSilo: 32203,     // Playmobil 19.283 + Modu 9.793 + Charm It 3.127
};

/* ── Yardımcılar ─────────────────────────────────────────────────────────── */
const tl = (n) => '₺' + Math.round(n).toLocaleString('tr-TR');
const sayi = (n) => Math.round(n).toLocaleString('tr-TR');
const kisa = (n) => (n >= 1000000 ? (n / 1000000).toFixed(2).replace('.', ',') + 'M' : n >= 1000 ? Math.round(n / 1000) + 'K' : String(Math.round(n)));
const kurus = (n) => '₺' + n.toFixed(2).replace('.', ',');
const yuzde = (p, t) => (t ? (p / t * 100) : 0);
const delta = (yeni, eski) => (eski ? ((yeni - eski) / eski * 100) : null);

const satirlar = (f) => PLAN.filter(f);
const topla = (rows, alan) => rows.reduce((a, r) => a + (r[alan] || 0), 0);
const tik = (r) => (r.cpc ? r.butce / r.cpc : 0);
const gosterim = (r) => (r.cpm ? r.butce / r.cpm * 1000 : 0);
const izlenme = (r) => (r.cpv ? r.butce / r.cpv : 0);
const ciktiMetni = (r) => {
  if (r.kaynak === 'esnek') return 'Kanal ve kampanya ay içinde performansa göre belirlenir';
  const p = [`${sayi(gosterim(r))} gösterim`];
  if (r.cpc) p.push(`${sayi(tik(r))} tıklama · ${kurus(r.cpc)} CPC`);
  if (r.cpv) p.push(`${sayi(izlenme(r))} izlenme · ${kurus(r.cpv)} CPV`);
  return p.join(' · ');
};

const TOPLAM_BUTCE = KALEMLER.reduce((a, k) => a + k.butce, 0);
const ONERI_TOPLAM = KALEMLER.reduce((a, k) => a + k.oneri, 0);
const kalemButce = (key) => topla(satirlar((r) => r.marka === key), 'butce');
const kalemMecra = (key, m) => topla(satirlar((r) => r.marka === key && r.mecra === m), 'butce');
const HUE = '#2a78d6';

/* 🔴 Dip toplam kontrolü: PLAN'ın marka toplamı markanın verdiği rakamı
   tutmuyorsa sayfa bunu SESSİZCE geçmez, kırmızı uyarı basar. Bu planın tek
   sözleşmesi bu — kanal dağılımı bize ait ama dip toplam markanın. */
const butceKontrol = KALEMLER.filter((k) => kalemButce(k.key) !== k.butce);

/* ═══════════════════════════ ALT BİLEŞENLER ═══════════════════════════ */

/* Logosu olmayan kalemler için tipografik kutu */
function KalemIsmi({ kalem, boy = 'h-9' }) {
  if (kalem.logo) return <img src={kalem.logo} alt={kalem.ad} className={`${boy} w-auto max-w-[110px] object-contain`} />;
  return (
    <span className={`${boy} inline-flex items-center px-2.5 rounded-md bg-gray-100 border border-gray-200 text-[12px] font-semibold text-gray-700 whitespace-nowrap`}>
      {kalem.ad}
    </span>
  );
}

/* Tek hue büyüklük çubuğu — buradaki renk kimlik değil BÜYÜKLÜK taşıyor.
   12 kalem var; 12 ayrı hue kategorik palette sığmıyor, o yüzden renk
   kodlaması yerine tek hue + yazılı tablo kullanılıyor. */
function Bar({ v, maks }) {
  const p = maks > 0 ? Math.max(v > 0 ? 0.8 : 0, (v / maks) * 100) : 0;
  return (
    <span className="inline-block w-full h-2 rounded-sm bg-gray-100 overflow-hidden align-middle">
      <span className="block h-full rounded-sm" style={{ width: `${p}%`, backgroundColor: HUE }} />
    </span>
  );
}

/* Bir kalemin tam kampanya tablosu */
function KalemPlanTablosu({ kalem }) {
  const rows = satirlar((r) => r.marka === kalem.key);
  const butce = topla(rows, 'butce');
  const mecralar = ['google', 'meta', 'tiktok'].filter((m) => rows.some((r) => r.mecra === m));
  const esnek = kalem.key === 'esnek';

  return (
    <div className="rounded-xl border overflow-hidden mb-6">
      <div className="px-4 py-3 flex items-center justify-between gap-3 border-b bg-gray-50">
        <div className="flex items-center gap-3 min-w-0">
          <span className="inline-block w-1.5 h-8 rounded-full flex-shrink-0" style={{ backgroundColor: HUE }} />
          <KalemIsmi kalem={kalem} boy="h-7" />
          <div className="min-w-0">
            <p className="font-semibold text-gray-800 text-sm truncate">{kalem.ad}</p>
            <p className="text-[11px] text-gray-500">
              {kalem.tur} · {kalem.onem}
              {kalem.ciro !== null && ` · 6 aylık ciro ${tl(kalem.ciro)}`}
              {kalem.urun !== null && (kalem.urun > 0 ? ` · ${sayi(kalem.urun)} ürün feed'de` : " · feed'de ürün YOK")}
            </p>
          </div>
        </div>
        <span className="px-3 py-1.5 rounded-full text-white text-sm font-semibold flex-shrink-0" style={{ backgroundColor: HUE }}>
          {tl(butce)}
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Hedef Kitle</th>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
              <th className="px-4 py-2.5 text-left text-[11px] font-medium text-gray-500 uppercase tracking-wider">Tahmini Çıktı</th>
              <th className="px-4 py-2.5 text-right text-[11px] font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700 align-top">
            {mecralar.map((m) => {
              const mr = rows.filter((r) => r.mecra === m);
              const mb = topla(mr, 'butce');
              return (
                <React.Fragment key={m}>
                  {mr.map((r, i) => (
                    <tr key={r.kampanya} className="hover:bg-gray-50">
                      {i === 0 && (
                        <td className="px-4 py-3 font-medium align-top" rowSpan={mr.length}>
                          <div className="flex items-center gap-2">
                            {!esnek && <img src={MECRA[m].logo} alt={MECRA[m].ad} className="w-5 h-5 object-contain" />}
                            <span className="whitespace-nowrap">{esnek ? 'Serbest' : MECRA[m].ad}</span>
                          </div>
                        </td>
                      )}
                      <td className="px-4 py-3">
                        {r.kampanya}
                        {r.sart === 'feed' && (
                          <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded border border-amber-300 bg-amber-50 text-amber-800 text-[10px] font-medium whitespace-nowrap">
                            feed şartlı
                          </span>
                        )}
                        {r.sart === 'hesap' && (
                          <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded border border-red-300 bg-red-50 text-red-800 text-[10px] font-medium whitespace-nowrap">
                            hesap bağlı değil
                          </span>
                        )}
                      </td>
                      <td className="px-4 py-3">{r.kitle}</td>
                      <td className="px-4 py-3"><Amac tip={r.amac} /></td>
                      <td className="px-4 py-3">
                        {ciktiMetni(r)}
                        {r.kaynak === 'benchmark' && <span className="block text-[10px] text-gray-400 mt-0.5">birim maliyet: pazar benchmark&#8217;ı</span>}
                      </td>
                      <td className="px-4 py-3 text-right font-medium whitespace-nowrap">{tl(r.butce)}</td>
                    </tr>
                  ))}
                  {!esnek && (
                    <tr className={`font-semibold ${MECRA[m].satir}`}>
                      <td className="px-4 py-2.5" colSpan={4}>{MECRA[m].ad} Toplam</td>
                      <td className="px-4 py-2.5">
                        {sayi(topla(mr.map((r) => ({ v: gosterim(r) })), 'v'))} gösterim
                        {topla(mr.map((r) => ({ v: tik(r) })), 'v') > 0 && ` · ${sayi(topla(mr.map((r) => ({ v: tik(r) })), 'v'))} tıklama`}
                        {topla(mr.map((r) => ({ v: izlenme(r) })), 'v') > 0 && ` · ${kisa(topla(mr.map((r) => ({ v: izlenme(r) })), 'v'))} izlenme`}
                      </td>
                      <td className="px-4 py-2.5 text-right whitespace-nowrap">{tl(mb)}</td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
            <tr className="bg-gray-800 text-white font-bold">
              <td className="px-4 py-3" colSpan={4}>{kalem.ad.toLocaleUpperCase('tr-TR')} TOPLAM</td>
              <td className="px-4 py-3">
                {esnek ? 'dağılım ay içinde' : `${sayi(topla(rows.map((r) => ({ v: gosterim(r) })), 'v'))} gösterim · ${sayi(topla(rows.map((r) => ({ v: tik(r) })), 'v'))} tıklama`}
                {!esnek && topla(rows.map((r) => ({ v: izlenme(r) })), 'v') > 0 && ` · ${kisa(topla(rows.map((r) => ({ v: izlenme(r) })), 'v'))} izlenme`}
              </td>
              <td className="px-4 py-3 text-right whitespace-nowrap">{tl(butce)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ═══════════════════════════ ANA SAYFA ═══════════════════════════ */

export default function HupalupaStoreEylul2026MarkaButcesi() {
  const maks = Math.max(...KALEMLER.map((k) => k.butce));

  /* Bizim kanal dağılımımız */
  const bizim = {
    google: topla(satirlar((r) => r.mecra === 'google' && r.kaynak !== 'esnek'), 'butce'),
    meta: topla(satirlar((r) => r.mecra === 'meta'), 'butce'),
    tiktok: topla(satirlar((r) => r.mecra === 'tiktok'), 'butce'),
    esnek: topla(satirlar((r) => r.kaynak === 'esnek'), 'butce'),
  };
  const bizimYoutube = topla(satirlar((r) => r.mecra === 'google' && /YouTube/.test(r.kampanya)), 'butce');

  /* Markanın Excel'indeki dağılım */
  const mt = (alan) => MARKA_DAGILIM.reduce((a, r) => a + r[alan], 0);
  const marka = {
    instagram: mt('instagram'), tiktok: mt('tiktok'), youtube: mt('youtube'),
    pinterest: mt('pinterest'), search: mt('search'), pmax: mt('pmax'),
  };
  const markaGoogle = marka.search + marka.pmax + marka.youtube;
  const bagliDegil = marka.tiktok + marka.pinterest;

  const feedSartli = topla(satirlar((r) => r.sart === 'feed'), 'butce');
  const hesapSartli = topla(satirlar((r) => r.sart === 'hesap'), 'butce');
  const genelTik = topla(PLAN.map((r) => ({ v: tik(r) })), 'v');
  const genelGosterim = topla(PLAN.map((r) => ({ v: gosterim(r) })), 'v');
  const genelIzlenme = topla(PLAN.map((r) => ({ v: izlenme(r) })), 'v');

  const KANAL_KIYAS = [
    { ad: 'Google Ads (Search + PMax + Shopping + YouTube)', biz: bizim.google, mrk: markaGoogle },
    { ad: 'Meta Ads (Instagram / Facebook)', biz: bizim.meta, mrk: marka.instagram },
    { ad: 'TikTok Ads', biz: bizim.tiktok, mrk: marka.tiktok, uyari: 'hesap bağlı değil' },
    { ad: 'Pinterest Ads', biz: 0, mrk: marka.pinterest, uyari: 'TR doğrudan satın alınamıyor' },
    { ad: 'Esnek (dağılımı ay içinde belirlenir)', biz: bizim.esnek, mrk: 150000 },
  ];

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">

        {/* ── Başlık ── */}
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-2">
              <img src="https://hupalupa.store/Data/EditorFiles/Devux/logo-1.svg" alt="Hupalupa Store" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA STORE — Eylül 2026 Medya Planı (Marka Bütçesi)</h2>
              <p className="text-sm text-gray-500">
                Bütçe markanın verdiği gibi · kanal ve kampanya dağılımı Glowytics
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Eylül 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Toplam: {tl(TOPLAM_BUTCE)}
            </span>
          </div>
        </div>

        <div className="p-6">

          {/* ── Dip toplam kontrolü ── */}
          {butceKontrol.length > 0 && (
            <div className="mb-6 p-4 rounded-xl bg-red-100 border border-red-300 text-[12px] text-red-900">
              <strong>Dip toplam tutmuyor.</strong> Şu kalemlerde kampanya toplamı markanın verdiği rakamdan farklı:{' '}
              {butceKontrol.map((k) => `${k.ad} (plan ${tl(kalemButce(k.key))} ≠ marka ${tl(k.butce)})`).join(' · ')}
            </div>
          )}

          {/* ── Bu plan nedir ── */}
          <div className="mb-6 p-4 rounded-xl bg-slate-50 border border-slate-200">
            <p className="text-xs font-semibold text-gray-800 mb-1.5">Bu plan neyi değiştiriyor</p>
            <p className="text-[11.5px] text-gray-700 leading-relaxed">
              Marka tarafı Eylül için kendi bütçe dağılımını çalıştı. <strong>Kalem bazındaki dip toplamlar aynen alındı</strong> —
              toplam {tl(TOPLAM_BUTCE)}, on bir marka kalemi ve {tl(150000)} esnek bütçe. Bizim 1 Eylül&#8217;deki önerimiz
              {' '}{tl(ONERI_TOPLAM)} idi; fark {tl(Math.abs(TOPLAM_BUTCE - ONERI_TOPLAM))} ({Math.round(delta(TOPLAM_BUTCE, ONERI_TOPLAM))}%).
              <strong> Bizim &#8220;Hupalupa Store genel&#8221; dediğimiz bütçe bu planda &#8220;esnek bütçe&#8221; kalemidir.</strong>
            </p>
            <p className="text-[11.5px] text-gray-700 leading-relaxed mt-1.5">
              <strong>Kanal dağılımı bize ait.</strong> Markanın Excel&#8217;indeki Instagram / TikTok / YouTube / Pinterest yüzdeleri
              kullanılmadı; gerekçeleri aşağıdaki &#8220;Kanal dağılımını neden değiştirdik&#8221; bölümünde tek tek yazılı.
              Kampanya kurguları, hedef kitleler ve birim maliyetler bu hesabın Ağustos 2026 gerçekleşen verisinden türetildi.
            </p>
          </div>

          {/* ── Eski plana ve ciro röntgenine bağlantı ── */}
          <div className="mb-6 p-3.5 rounded-xl bg-blue-50 border border-blue-200 flex flex-col sm:flex-row sm:items-center gap-2 sm:justify-between">
            <p className="text-[11.5px] text-blue-900 leading-relaxed">
              Bizim 1 Eylül&#8217;deki önerimiz ({tl(ONERI_TOPLAM)}) ve altındaki <strong>Ciro Röntgeni</strong>
              {' '}(GA4, son 6 ay, marka bazında ciro) ayrı sayfada duruyor — bu planın gerekçelerinin çoğu oradaki veriye dayanıyor.
            </p>
            <a href="/budget/hupalupa-store-eylul-2026-medya-plani"
               className="inline-flex items-center justify-center px-3 py-1.5 rounded-lg bg-blue-600 text-white text-[11.5px] font-semibold whitespace-nowrap hover:bg-blue-700">
              Bizim planımızı aç →
            </a>
          </div>

          {/* ── En büyük iki uyarı ── */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div className="p-4 rounded-xl bg-rose-50 border border-rose-200">
              <p className="text-xs font-semibold text-rose-900 mb-1">
                Genel katalog motoru {Math.round(delta(150000, AGUSTOS.genelMotor))}% küçülüyor
              </p>
              <p className="text-[11px] text-rose-800 leading-relaxed">
                Ağustos&#8217;ta marka ayrımı olmayan genel katalog ve arama kampanyaları <strong>{tl(AGUSTOS.genelMotor)}</strong> harcadı;
                hesabın en verimli birimi bu (CPC ₺2,49-3,15, ROAS 3,27-9,66). Bu planda karşılığı olan esnek bütçe <strong>{tl(150000)}</strong>.
                Buna karşılık marka silolarına <strong>{tl(TOPLAM_BUTCE - 150000)}</strong> gidiyor — Ağustos&#8217;ta marka bazına ayrılmış
                kampanyaların toplamı {tl(AGUSTOS.markaSilo)}&#8217;tü, yani <strong>{Math.round((TOPLAM_BUTCE - 150000) / AGUSTOS.markaSilo)} kat</strong> büyüme.
                O kampanyaların Ağustos ROAS&#8217;ı 0,31-1,42 aralığındaydı. <strong>Planın en büyük riski budur</strong> ve aşağıdaki
                &#8220;ürün seti&#8221; kurgusu bu riski azaltmak için var.
              </p>
            </div>
            <div className="p-4 rounded-xl bg-red-50 border border-red-200">
              <p className="text-xs font-semibold text-red-900 mb-1">
                Markanın planındaki {tl(bagliDegil)} bağlı olmayan mecrada
              </p>
              <p className="text-[11px] text-red-800 leading-relaxed">
                Excel&#8217;de TikTok&#8217;a {tl(marka.tiktok)}, Pinterest&#8217;e {tl(marka.pinterest)} ayrılmış —
                toplamın <strong>%{yuzde(bagliDegil, TOPLAM_BUTCE).toFixed(1).replace('.', ',')}</strong>&#8217;i.
                Store&#8217;da <strong>ikisinin de reklam hesabı bağlı değil</strong> (3 Eyl&#8217;de kontrol edildi).
                Üstelik <strong>Pinterest Türkiye&#8217;de doğrudan reklam satın alınabilen bir ülke değil</strong>, satın alma
                Aleph üzerinden yürüyor — Eylül içinde açılması gerçekçi değil. Ağustos planındaki {tl(25000)} TikTok bütçesi de
                aynı sebeple harcanamamıştı. Bizim planımızda TikTok {tl(bizim.tiktok)}&#8217;e indirildi ve
                <strong> &#8220;hesap bağlı değil&#8221;</strong> diye işaretlendi; Pinterest hiç yok.
              </p>
            </div>
          </div>

          {/* ══════════ KALEM BAZLI BÜTÇE ══════════ */}
          <h3 className="text-base font-bold text-gray-800 mb-1">Kalem Bazlı Bütçe — markadan geldiği gibi</h3>
          <p className="text-xs text-gray-500 mb-4">
            Bütçe sütunu markanın verdiği rakam, değiştirilmedi. Ciro sütunu GA4 ürün performansı (1 Mar – 31 Ağu 2026).
          </p>
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2.5 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Kalem</th>
                    <th className="px-3 py-2.5 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Büyüklük</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Pay</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Bizim Önerimiz</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">6 Aylık Ciro</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Bütçe / Aylık Ciro</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Google</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Meta</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">TikTok</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Feed</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px]">
                  {KALEMLER.map((k) => {
                    const aylikCiro = k.ciro === null ? null : k.ciro / 6;
                    const kat = aylikCiro === null ? null : (aylikCiro > 0 ? k.butce / aylikCiro : Infinity);
                    const d = k.oneri ? delta(k.butce, k.oneri) : null;
                    return (
                      <tr key={k.key} className={k.ciro === 0 ? 'bg-rose-50/60' : 'hover:bg-gray-50'}>
                        <td className="px-3 py-2.5 font-medium text-gray-800 whitespace-nowrap">{k.ad}</td>
                        <td className="px-3 py-2.5 w-[130px]"><Bar v={k.butce} maks={maks} /></td>
                        <td className="px-3 py-2.5 text-right font-semibold text-gray-900 tabular-nums whitespace-nowrap">{tl(k.butce)}</td>
                        <td className="px-3 py-2.5 text-right text-gray-600 tabular-nums whitespace-nowrap">%{yuzde(k.butce, TOPLAM_BUTCE).toFixed(1).replace('.', ',')}</td>
                        <td className="px-3 py-2.5 text-right tabular-nums whitespace-nowrap">
                          {k.oneri ? (
                            <>
                              <span className="text-gray-600">{tl(k.oneri)}</span>
                              <span className={`ml-1.5 font-semibold ${d >= 0 ? 'text-emerald-700' : 'text-rose-700'}`}>{d > 0 ? '+' : ''}{Math.round(d)}%</span>
                            </>
                          ) : <span className="text-blue-600 font-medium">yeni kalem</span>}
                        </td>
                        <td className={`px-3 py-2.5 text-right tabular-nums whitespace-nowrap ${k.ciro === 0 ? 'font-semibold text-rose-700' : 'text-gray-700'}`}>
                          {k.ciro === null ? '—' : tl(k.ciro)}
                        </td>
                        <td className="px-3 py-2.5 text-right tabular-nums whitespace-nowrap">
                          {kat === null ? <span className="text-gray-400">—</span>
                            : kat === Infinity ? <span className="font-semibold text-rose-700">ölçülemez</span>
                            : <span className={kat >= 3 ? 'font-semibold text-rose-700' : kat >= 1 ? 'font-semibold text-amber-700' : 'text-gray-600'}>{kat.toFixed(1).replace('.', ',')}×</span>}
                        </td>
                        <td className="px-3 py-2.5 text-right tabular-nums whitespace-nowrap text-gray-600">{kalemMecra(k.key, 'google') ? tl(kalemMecra(k.key, 'google')) : '—'}</td>
                        <td className="px-3 py-2.5 text-right tabular-nums whitespace-nowrap text-gray-600">{kalemMecra(k.key, 'meta') ? tl(kalemMecra(k.key, 'meta')) : '—'}</td>
                        <td className="px-3 py-2.5 text-right tabular-nums whitespace-nowrap text-gray-600">{kalemMecra(k.key, 'tiktok') ? tl(kalemMecra(k.key, 'tiktok')) : '—'}</td>
                        <td className={`px-3 py-2.5 text-right tabular-nums whitespace-nowrap ${k.urun === 0 ? 'font-semibold text-rose-700' : 'text-gray-600'}`}>
                          {k.urun === null ? '—' : k.urun === 0 ? '0 ürün' : `${sayi(k.urun)} ürün`}
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-3 py-3" colSpan={2}>TOPLAM</td>
                    <td className="px-3 py-3 text-right tabular-nums">{tl(TOPLAM_BUTCE)}</td>
                    <td className="px-3 py-3 text-right tabular-nums">%100</td>
                    <td className="px-3 py-3 text-right tabular-nums">{tl(ONERI_TOPLAM)}</td>
                    <td className="px-3 py-3" colSpan={2} />
                    <td className="px-3 py-3 text-right tabular-nums">{tl(bizim.google)}</td>
                    <td className="px-3 py-3 text-right tabular-nums">{tl(bizim.meta)}</td>
                    <td className="px-3 py-3 text-right tabular-nums">{tl(bizim.tiktok)}</td>
                    <td className="px-3 py-3" />
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-gray-50 border-t text-[10.5px] text-gray-600 leading-relaxed">
              <strong>Bütçe / Aylık Ciro</strong> = kalemin Eylül bütçesi ÷ son 6 aydaki aylık ortalama cirosu. 1,0× &#8220;bir aylık cirosu kadar bütçe&#8221; demek.
              Google / Meta / TikTok sütunları <strong>bizim</strong> dağılımımızdır; satır toplamları soldaki bütçeye kapanır.
              Esnek bütçenin ciro karşılığı yazılmadı: o kalem tek bir markaya değil katalogun tamamına çalışıyor.
              Yabancı dil kitaplarının cirosu <em>Çocuk Kitapları &gt; İngilizce Çocuk Kitapları</em> kategorisinden alındı; marka satırlarıyla kısmen çakışabilir.
            </div>
          </div>


          {/* ══════════ BİZ ŞÖYLE YAPARDIK ══════════
              Yukarıdaki tablo markanın bütçesidir ve DEĞİŞMEZ. Bu blok onun
              altında duran ayrı bir öneridir; dip toplam ikisinde de aynı. */}
          <h3 className="text-base font-bold text-gray-800 mb-1">Biz şöyle yapardık — aynı toplam, farklı dağılım</h3>
          <p className="text-xs text-gray-500 mb-4">
            Yukarıdaki tablo markanın bütçesidir ve olduğu gibi duruyor. Bu, onun altına konan <strong>ayrı bir öneridir</strong>:
            toplam yine {tl(ONERI_YENI_TOPLAM)} — tek kuruş eklenmiyor, sadece yeri değişiyor.
          </p>

          {/* Nereden nereye */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4">
              <p className="text-xs font-semibold text-emerald-900 mb-1.5">
                Alan iki kalem · +{tl(ONERI.filter((o) => oneriButce(o.key) > KALEMLER.find((k) => k.key === o.key).butce).reduce((a, o) => a + (o.yeni - KALEMLER.find((k) => k.key === o.key).butce), 0)).slice(1)}
              </p>
              <ul className="text-[11.5px] text-emerald-900 leading-relaxed space-y-1">
                <li><strong>Okul Setleri / B2S</strong> {tl(50000)} → <strong>{tl(200000)}</strong> (+{tl(150000).slice(1)})</li>
                <li><strong>Playmobil</strong> {tl(80000)} → <strong>{tl(150000)}</strong> (+{tl(70000).slice(1)})</li>
              </ul>
            </div>
            <div className="rounded-xl border border-rose-200 bg-rose-50 p-4">
              <p className="text-xs font-semibold text-rose-900 mb-1.5">Veren yedi kalem · −{tl(220000).slice(1)}</p>
              <p className="text-[11.5px] text-rose-900 leading-relaxed">
                Esnek bütçe −{tl(100000).slice(1)} · Antonio Juan −{tl(35000).slice(1)} · X Mud −{tl(25000).slice(1)} ·
                Zoo Family −{tl(15000).slice(1)} · Modu −{tl(15000).slice(1)} · Charm It −{tl(15000).slice(1)} · Meli −{tl(15000).slice(1)}
              </p>
              <p className="text-[11px] text-rose-800 leading-relaxed mt-1.5 pt-1.5 border-t border-rose-200">
                <strong>Talimattan bir sapma var, bilerek:</strong> kaydırılacak tutar {tl(220000)}; esnekten {tl(100000)} gelince
                kalan {tl(120000)}. Modu + Antonio Juan + Meli&#8217;nin <strong>toplamı {tl(140000)}</strong> — {tl(120000)}&#8217;i o üçünden almak
                üçünü de fiilen kapatmak olurdu. Bu yüzden {tl(65000)}&#8217;i o üç kalemden, kalan {tl(55000)}&#8217;i
                &#8220;bütçe / aylık ciro&#8221; sıralamasının en tepesindeki üç kalemden aldık (X Mud 51,4× · Charm It 22,7× ·
                Zoo Family beş ay üst üste düşen trend).
              </p>
            </div>
          </div>

          <div className="rounded-xl border overflow-hidden mb-5">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2.5 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Kalem</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Marka Bütçesi</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Bizim Önerimiz</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Fark</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">6 Aylık Ciro</th>
                    <th className="px-3 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Oran: Marka → Biz</th>
                    <th className="px-3 py-2.5 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Gerekçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px]">
                  {[...KALEMLER].sort((a, b) => oneriButce(b.key) - oneriButce(a.key)).map((k) => {
                    const yeni = oneriButce(k.key);
                    const f = yeni - k.butce;
                    const aylik = k.ciro === null ? null : k.ciro / 6;
                    const oranEski = aylik === null ? null : (aylik > 0 ? k.butce / aylik : Infinity);
                    const oranYeni = aylik === null ? null : (aylik > 0 ? yeni / aylik : Infinity);
                    const o = ONERI_MAP[k.key];
                    const oranYaz = (v) => (v === null ? '—' : v === Infinity ? 'ölçülemez' : v.toFixed(1).replace('.', ',') + '×');
                    return (
                      <tr key={k.key} className={f === 0 ? 'hover:bg-gray-50' : f > 0 ? 'bg-emerald-50/50' : 'bg-rose-50/40'}>
                        <td className="px-3 py-2.5 font-medium text-gray-800 whitespace-nowrap align-top">{k.ad}</td>
                        <td className="px-3 py-2.5 text-right tabular-nums whitespace-nowrap text-gray-500 align-top">{tl(k.butce)}</td>
                        <td className="px-3 py-2.5 text-right tabular-nums whitespace-nowrap font-semibold text-gray-900 align-top">{tl(yeni)}</td>
                        <td className={`px-3 py-2.5 text-right tabular-nums whitespace-nowrap font-semibold align-top ${f > 0 ? 'text-emerald-700' : f < 0 ? 'text-rose-700' : 'text-gray-400'}`}>
                          {f === 0 ? 'aynı' : `${f > 0 ? '+' : '−'}${tl(Math.abs(f)).slice(1)}`}
                        </td>
                        <td className={`px-3 py-2.5 text-right tabular-nums whitespace-nowrap align-top ${k.ciro === 0 ? 'font-semibold text-rose-700' : 'text-gray-700'}`}>
                          {k.ciro === null ? '—' : tl(k.ciro)}
                        </td>
                        <td className="px-3 py-2.5 text-right tabular-nums whitespace-nowrap align-top text-gray-600">
                          {oranEski === null ? '—' : <>{oranYaz(oranEski)} <span className="text-gray-400">→</span>{' '}
                            <span className={oranYeni === Infinity || oranYeni >= 3 ? 'font-semibold text-rose-700' : oranYeni >= 1 ? 'font-semibold text-amber-700' : 'font-semibold text-emerald-700'}>{oranYaz(oranYeni)}</span></>}
                        </td>
                        <td className="px-3 py-2.5 text-gray-600 leading-relaxed min-w-[280px] align-top">
                          {o ? o.gerekce : <span className="text-gray-400">Değişmedi.</span>}
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-3 py-3">TOPLAM</td>
                    <td className="px-3 py-3 text-right tabular-nums">{tl(TOPLAM_BUTCE)}</td>
                    <td className="px-3 py-3 text-right tabular-nums">{tl(ONERI_YENI_TOPLAM)}</td>
                    <td className="px-3 py-3 text-right tabular-nums">{ONERI_YENI_TOPLAM === TOPLAM_BUTCE ? 'aynı' : 'TUTMUYOR'}</td>
                    <td className="px-3 py-3" colSpan={3} />
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-gray-50 border-t text-[10.5px] text-gray-600 leading-relaxed">
              <strong>Oran</strong> = kalemin bütçesi ÷ son 6 aydaki aylık ortalama cirosu; solda markanın bütçesiyle, sağda bizim önerimizle.
              1,0&#8217;ın altı &#8220;bir aylık cirosundan az bütçe&#8221;, 3,0&#8217;ın üstü ise bütçenin cirodan kopmuş olması demek.
              Bu öneri <strong>yalnız kalem bütçelerini</strong> değiştirir; aşağıdaki kampanya tabloları hâlâ markanın bütçesine göre kuruludur.
              Öneri onaylanırsa kampanya satırları da aynı oranlarla yeniden ölçeklenir.
            </div>
          </div>

          {/* Öneri onaylanırsa ne değişir */}
          <div className="mb-8 p-4 rounded-xl bg-blue-50 border border-blue-200">
            <p className="text-xs font-semibold text-blue-900 mb-1.5">Bu öneri kabul edilirse planın hikâyesi ne oluyor</p>
            <ul className="text-[11.5px] text-blue-900 leading-relaxed space-y-1 list-disc pl-4">
              <li>
                <strong>Katalog motoru büyüyor, küçülmüyor.</strong> Esnek bütçe {tl(150000)} → {tl(50000)} inse de
                Okul Setleri {tl(50000)} → {tl(200000)} çıkıyor ve o da aynı Advantage+ motorunun içinde bir ürün seti.
                İkisi birlikte <strong>{tl(200000)} → {tl(250000)}</strong>. Sayfanın başındaki &#8220;genel motor küçülüyor&#8221; uyarısı
                bu öneriyle hafifler.
              </li>
              <li>
                <strong>Verisi olan kaleme para gidiyor.</strong> Okul/kırtasiye altı ayda {tl(1228160)} sattı — planın en kanıtlı kalemi
                ve en az bütçeyi alan kalemdi. {tl(200000)} ile oranı 1,0× oluyor, yani bir aylık cirosu kadar bütçe.
              </li>
              <li>
                <strong>Sıfır satan kaleme dokunulmadı.</strong> NeeDoh {tl(600000)}&#8217;de kalıyor — o karar markanın ve bu öneri onu
                tartışmıyor. Ama altı aylık cirosu hâlâ {tl(0)} ve feed&#8217;de hâlâ 0 ürün var; ön koşul değişmedi.
              </li>
              <li>
                <strong className="text-rose-700">Tek zayıf halka Playmobil.</strong> {tl(150000)} ile oranı 16,1× — tablodaki en yüksek ikinci değer.
                Gerekçe mevcut ciro değil, tırmanan trend ve 3.600/ay marka araması. Ay ortasında ölçülüp geri alınabilecek şekilde
                kurulmalı.
              </li>
            </ul>
          </div>

          {/* ══════════ KANAL KIYASI ══════════ */}
          <h3 className="text-base font-bold text-gray-800 mb-1">Kanal dağılımını neden değiştirdik</h3>
          <p className="text-xs text-gray-500 mb-4">
            Solda markanın Excel&#8217;i, sağda bizim dağılımımız. Dip toplam ikisinde de {tl(TOPLAM_BUTCE)}.
          </p>
          <div className="rounded-xl border overflow-hidden mb-5">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2.5 text-left text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Kanal</th>
                    <th className="px-4 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Markanın planı</th>
                    <th className="px-4 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Pay</th>
                    <th className="px-4 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Bizim planımız</th>
                    <th className="px-4 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Pay</th>
                    <th className="px-4 py-2.5 text-right text-[10.5px] font-medium text-gray-500 uppercase tracking-wider">Fark</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px]">
                  {KANAL_KIYAS.map((k) => {
                    const f = k.biz - k.mrk;
                    return (
                      <tr key={k.ad} className="hover:bg-gray-50">
                        <td className="px-4 py-2.5 font-medium text-gray-800">
                          {k.ad}
                          {k.uyari && (
                            <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded border border-red-300 bg-red-50 text-red-800 text-[10px] font-medium whitespace-nowrap">
                              {k.uyari}
                            </span>
                          )}
                        </td>
                        <td className="px-4 py-2.5 text-right tabular-nums text-gray-600">{k.mrk ? tl(k.mrk) : '—'}</td>
                        <td className="px-4 py-2.5 text-right tabular-nums text-gray-500">%{yuzde(k.mrk, TOPLAM_BUTCE).toFixed(1).replace('.', ',')}</td>
                        <td className="px-4 py-2.5 text-right tabular-nums font-semibold text-gray-900">{k.biz ? tl(k.biz) : '—'}</td>
                        <td className="px-4 py-2.5 text-right tabular-nums text-gray-500">%{yuzde(k.biz, TOPLAM_BUTCE).toFixed(1).replace('.', ',')}</td>
                        <td className={`px-4 py-2.5 text-right tabular-nums font-semibold ${f > 0 ? 'text-emerald-700' : f < 0 ? 'text-rose-700' : 'text-gray-400'}`}>
                          {f === 0 ? '—' : `${f > 0 ? '+' : '−'}${tl(Math.abs(f)).slice(1)}`}
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3">TOPLAM</td>
                    <td className="px-4 py-3 text-right tabular-nums">{tl(markaGoogle + marka.instagram + marka.tiktok + marka.pinterest + 150000)}</td>
                    <td className="px-4 py-3 text-right tabular-nums">%100</td>
                    <td className="px-4 py-3 text-right tabular-nums">{tl(bizim.google + bizim.meta + bizim.tiktok + bizim.esnek)}</td>
                    <td className="px-4 py-3 text-right tabular-nums">%100</td>
                    <td className="px-4 py-3" />
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-gray-50 border-t text-[10.5px] text-gray-600 leading-relaxed">
              Excel&#8217;in <strong>YouTube</strong> sütunu ({tl(marka.youtube)}) Google satırının içine, <strong>Instagram</strong> sütunu
              ({tl(marka.instagram)}) Meta satırının içine sayıldı — ikisi ayrı mecra değil, aynı hesabın yerleşimi.
              Bizim planımızda YouTube {tl(bizimYoutube)} (NeeDoh {tl(50000)} + Playmobil {tl(6000)}).
            </div>
          </div>

          {/* ── Beş gerekçe ── */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 text-[11.5px] text-gray-700">
            <div className="rounded-xl border border-gray-200 bg-white p-4">
              <p className="font-semibold text-gray-800 mb-1">1 · Google payı artırıldı ({tl(markaGoogle)} → {tl(bizim.google)})</p>
              <p className="leading-relaxed">
                Ağustos&#8217;ta bu hesapta Google <strong>{tl(AGUSTOS.google.harcama)}</strong> harcayıp <strong>{tl(AGUSTOS.google.ciro)}</strong> ciro
                getirdi (ROAS {AGUSTOS.google.roas.toFixed(2).replace('.', ',')}); Meta <strong>{tl(AGUSTOS.meta.harcama)}</strong> harcayıp
                {' '}<strong>{tl(AGUSTOS.meta.ciro)}</strong> (ROAS {AGUSTOS.meta.roas.toFixed(2).replace('.', ',')}). Google <strong>neredeyse iki kat</strong> verimli
                çalışıyor ve Excel&#8217;de en az pay alan taraf oydu.
              </p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white p-4">
              <p className="font-semibold text-gray-800 mb-1">2 · Marka silosu ayrı kampanya değil, katalog içinde ÜRÜN SETİ</p>
              <p className="leading-relaxed">
                Ağustos&#8217;ta marka bazına ayrılmış Meta kampanyaları <strong>₺10,74-14,57 CPC</strong> ve <strong>0,31-1,42 ROAS</strong> ile çalıştı;
                marka ayrımsız katalog motoru <strong>₺2,49-3,15 CPC</strong> ve <strong>3,27-9,66 ROAS</strong>. Aradaki fark hedeflemeden geliyor:
                yeni kampanya kitleyi daraltıyor ve öğrenmeyi sıfırdan başlatıyor. Bu planda her marka
                <strong> Advantage+ katalog motorunun içinde bir ürün seti</strong> olarak kuruluyor — bütçe marka bazında yönetilebiliyor
                ama motorun öğrenmesi bozulmuyor.
              </p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white p-4">
              <p className="font-semibold text-gray-800 mb-1">3 · Bağlı olmayan mecraya bütçe yazılmadı</p>
              <p className="leading-relaxed">
                TikTok {tl(marka.tiktok)} → <strong>{tl(bizim.tiktok)}</strong>, Pinterest {tl(marka.pinterest)} → <strong>{tl(0)}</strong>.
                Store&#8217;da ikisinin de hesabı bağlı değil; Pinterest ayrıca <strong>Türkiye&#8217;de doğrudan satın alınamıyor</strong> (Aleph üzerinden).
                Kalan TikTok satırları <strong>&#8220;hesap bağlı değil&#8221;</strong> etiketiyle duruyor: hesap Eylül&#8217;ün ilk haftasında
                açılmazsa {tl(hesapSartli)} Meta Video Views&#8217;a aktarılır.
              </p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white p-4">
              <p className="font-semibold text-gray-800 mb-1">4 · Arama hacmi olmayan markada Search kurulmadı</p>
              <p className="leading-relaxed">
                Charm It&#8217;in aylık marka araması <strong>70</strong>, X Mud&#8217;ın <strong>10</strong>, Zoo Family&#8217;nin <strong>90</strong>.
                Bu markalarda marka arama kampanyası kurmak bütçeyi boşa yakar; onun yerine <strong>kategori araması</strong>
                (&#8220;slime&#8221; 27.100/ay, &#8220;çocuk fotoğraf makinesi&#8221;) ve <strong>Shopping/PMax</strong> kullanıldı. NeeDoh ve
                Playmobil ise tersine — {sayi(49500)} ve {sayi(3600)} aylık arama — orada marka araması ilk sırada.
              </p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white p-4">
              <p className="font-semibold text-gray-800 mb-1">5 · Feed&#8217;i olmayan markaya katalog bütçesi yazılmadı</p>
              <p className="leading-relaxed">
                NeeDoh kaynak feed&#8217;de <strong>0 ürün</strong>; GA4&#8217;e göre son 6 ayda <strong>{tl(0)}</strong> satmış.
                Bu markadaki katalog, PMax ve Shopping satırları <strong>&#8220;feed şartlı&#8221;</strong> işaretli —
                toplam <strong>{tl(feedSartli)}</strong>. Feed açılmazsa bu tutar harcanamaz; arama, YouTube ve video satırları
                ({tl(600000 - feedSartli)}) feed olmadan da çalışır çünkü trafiği ürün sayfalarına değil koleksiyon sayfasına gönderebiliriz.
              </p>
            </div>
            <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
              <p className="font-semibold text-amber-900 mb-1">Değiştirmediğimiz şey: Excel&#8217;in içerik fikirleri</p>
              <p className="leading-relaxed text-amber-900">
                Markanın format önerileri (&#8220;çantamda ne var&#8221; trendi, ASMR slime videosu, DIY bileklik, unboxing, okul listesi
                checklist&#8217;i) <strong>kreatif brief olarak aynen geçerli</strong> — biz bütçenin hangi kanalda duracağını değiştirdik,
                hangi içeriğin çekileceğini değil. Bu fikirler yukarıdaki kampanyaların &#8220;Video Views&#8221; ve
                &#8220;Sales&#8221; satırlarının kreatif girdisidir.
              </p>
            </div>
          </div>

          {/* ══════════ KALEM PLANLARI ══════════ */}
          <h3 className="text-base font-bold text-gray-800 mb-1">Kalem Bazlı Medya Planları</h3>
          <p className="text-xs text-gray-500 mb-4">
            Her kalemin dip toplamı markanın verdiği rakama kapanır. Kampanya kurgusu, hedef kitle ve kanal dağılımı bize aittir.
          </p>
          {KALEMLER.map((k) => <KalemPlanTablosu key={k.key} kalem={k} />)}

          {/* ══════════ TOPLAM ÇIKTI ══════════ */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Planın Toplam Çıktısı</div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 p-4">
              {[
                { ad: 'Toplam bütçe', v: tl(TOPLAM_BUTCE), alt: `${KALEMLER.length} kalem · ${PLAN.length} kampanya satırı` },
                { ad: 'Tahmini gösterim', v: kisa(genelGosterim), alt: 'esnek bütçe hariç' },
                { ad: 'Tahmini tıklama', v: sayi(genelTik), alt: `ort. ${kurus(topla(satirlar((r) => r.cpc), 'butce') / genelTik)} CPC` },
                { ad: 'Tahmini video izlenme', v: kisa(genelIzlenme), alt: 'YouTube + Meta + TikTok' },
              ].map((s) => (
                <div key={s.ad} className="rounded-xl border border-gray-200 bg-white p-3.5">
                  <p className="text-[11px] text-gray-500">{s.ad}</p>
                  <p className="text-xl font-bold text-gray-900 mt-1 tabular-nums">{s.v}</p>
                  <p className="text-[11px] text-gray-500 mt-0.5">{s.alt}</p>
                </div>
              ))}
            </div>
          </div>

          {/* ══════════ ÖN KOŞULLAR ══════════ */}
          <div className="rounded-xl border border-red-200 overflow-hidden mb-8">
            <div className="bg-red-50 px-4 py-3 font-semibold text-red-900">
              Ön koşullar — bunlar yapılmadan planın {tl(feedSartli + hesapSartli)}&#8217;lik kısmı yayına alınamaz
            </div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[12px] text-gray-700">
              <div className="rounded-lg border border-red-200 bg-red-50 p-3">
                <p className="font-semibold text-red-900 mb-1">1 · NeeDoh ürünleri feed&#8217;e girmeli ({tl(feedSartli)})</p>
                <p className="leading-relaxed">
                  4.325 ürünlük kaynak feed&#8217;de tek bir NeeDoh yok; GA4&#8217;te de son 6 ayda sıfır satış görünüyor.
                  Ama sitenin ana sayfasında NeeDoh banner&#8217;ı yayında — ürünler mağazada var, sorun feed&#8217;e akmaması.
                  Ayın ilk haftası içinde çözülmeli.
                </p>
              </div>
              <div className="rounded-lg border border-red-200 bg-red-50 p-3">
                <p className="font-semibold text-red-900 mb-1">2 · TikTok reklam hesabı bağlanmalı ({tl(hesapSartli)})</p>
                <p className="leading-relaxed">
                  Store&#8217;da TikTok bağlantısı yok; Ağustos&#8217;ta da bu yüzden {tl(25000)} harcanamadı.
                  HUPALUPA Eğlence tarafında aktif bir hesap var, Store için ayrıca yetkilendirme gerekiyor.
                  Bağlanmazsa bu tutar Meta Video Views&#8217;a aktarılır.
                </p>
              </div>
              <div className="rounded-lg border border-amber-200 bg-amber-50 p-3">
                <p className="font-semibold text-amber-900 mb-1">3 · Marka bazlı ölçüm ve ürün setleri kurulmalı</p>
                <p className="leading-relaxed">
                  Bütçe kalem bazında yönetilecekse raporlama da öyle olmalı: Meta&#8217;da <strong>katalog ürün seti</strong>,
                  Google&#8217;da <strong>ürün grubu ve asset grubu</strong> ayrımı. Bugün bu ayrım yalnız kampanya adında var;
                  katalog motorunun içindeki marka satışı görünmüyor. Bu kurulmadan &#8220;hangi marka ne getirdi&#8221; sorusu
                  Eylül sonunda da yanıtlanamaz.
                </p>
              </div>
            </div>
          </div>

          {/* ══════════ NOT ══════════ */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <p className="text-xs font-semibold text-amber-800">Projeksiyon Notu</p>
            <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
              <strong>Bütçe rakamları markadan gelmiştir ve değiştirilmemiştir.</strong> Kanal dağılımı, kampanya kurgusu ve
              hedef kitleler Glowytics&#8217;e aittir. Birim maliyetler <strong>Ağustos 2026 gerçekleşen verisinden</strong> türetilmiştir
              (Google {kurus(AGUSTOS.google.cpc)} CPC / {tl(AGUSTOS.google.cpm)} CPM, Meta {kurus(AGUSTOS.meta.cpc)} CPC / {tl(AGUSTOS.meta.cpm)} CPM);
              hesapta karşılığı olmayan satırlar (TikTok&#8217;un tamamı, video izlenme maliyetleri) <strong>pazar benchmark&#8217;ıdır</strong>
              ve tabloda öyle işaretlidir. Marka katalog setlerinde kullanılan {kurus(4.50)} CPC bir <strong>varsayımdır</strong>:
              Ağustos&#8217;ta marka-izole kampanyalar ₺10,74-14,57, katalog motoru ₺2,49-3,15 ile çalıştı; varsayım setlerin motorun
              içinde kurulacağıdır. Ayrı kampanya olarak kurulursa CPC iki katına çıkar ve tıklama tahminleri yarılanır.
              <strong> Dönüşüm adedi ve ciro projeksiyonu bilerek verilmemiştir:</strong> NeeDoh&#8217;un Türkiye&#8217;de tek bir ay bile
              reklam geçmişi yok, yeni açılan kalemlerin hiçbirinde geçmiş ROAS verisi yok. Ağustos&#8217;ta gerçekleşen birleşik ROAS
              {' '}{AGUSTOS.toplam.roas.toFixed(2).replace('.', ',')}&#8217;tür; hedef, bütçe {(TOPLAM_BUTCE / AGUSTOS.toplam.harcama).toFixed(1).replace('.', ',')} katına
              çıkarken bunun <strong>3,00&#8217;ın altına düşmemesidir</strong>. Ciro rakamları GA4 ürün performansından, 1 Mart – 31 Ağustos 2026
              aralığından alınmıştır. Arama hacimleri Google Keyword Planner&#8217;dan, mutlak sayı değil <strong>büyüklük mertebesi</strong>
              olarak okunmalıdır.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
